// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-fields {
  width: 90%;
  margin-top: 0px;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: -5px;
}

.checkbox-setting-row {
  display: flex;
  align-items: center;
  margin: 0 40px 0 15px;
}

.checkbox-label {
  flex: auto;
  min-width: 0;
  width: 180px;
  position: relative;
  box-sizing: border-box;
}

.checkbox-icons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 4px 15px 0 0;
}

.setting-icon {
  cursor: pointer;
}

.settings {
  overflow-y: auto;
  max-height: 53vh;
}

.setting {
  display: inline-block;
}
@media (max-width: 767px) {
  .setting {
    width: 100%;
  }
}
@media (min-width: 768px) {
  .setting {
    width: 50%;
  }
}

.setting-options {
  padding: 12px 5px;
  cursor: pointer;
}

.settings-container {
  display: inline;
}
@media (max-width: 767px) {
  .settings-container {
    width: 50vh;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .settings-container {
    width: 65vh;
  }
}
@media (min-width: 992px) {
  .settings-container {
    width: 75vh;
  }
}

/*TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
.mat-select-value-text {
  white-space: break-spaces !important;
  overflow: visible !important;
}

.row-padding {
  margin-top: 15px;
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.tooltip {
  display: block;
  position: relative;
  top: 2em;
  right: 100%;
  width: 140px;
  height: 96px;
  /*margin-left: -76px;*/
  color: #FFFFFF;
  background: #000000;
  line-height: 96px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 4px 3px 10px #800000;
}

.tooltip:after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -8px;
  width: 0;
  height: 0;
  border-bottom: 8px solid #000000;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/organizations/organization-settings/organization-settings.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;AAEJ;;AACA;EACI,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAEJ;;AACA;EACI,aAAA;EACA,SAAA;EACA,yBAAA;EACA,qBAAA;AAEJ;;AACA;EACI,eAAA;AAEJ;;AACA;EACI,gBAAA;EACA,gBAAA;AAEJ;;AACA;EACI,qBAAA;AAEJ;AADI;EAFJ;IAGQ,WAAA;EAIN;AACF;AAHI;EALJ;IAMQ,UAAA;EAMN;AACF;;AAHA;EACI,iBAAA;EACA,eAAA;AAMJ;;AAHA;EACI,eAAA;AAMJ;AALI;EAFJ;IAGQ,WAAA;EAQN;AACF;AAPI;EALJ;IAMQ,WAAA;EAUN;AACF;AATI;EARJ;IASQ,WAAA;EAYN;AACF;;AATA,2HAAA;AACA;EACI,oCAAA;EACA,4BAAA;AAYJ;;AATA;EACI,gBAAA;EACA,4BAAA;EACA,2BAAA;AAYJ;;AATA;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;AAYJ;;AAVA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;AAaJ","sourcesContent":[".form-fields {\n    width: 90%;\n    margin-top: 0px;\n    margin-left: 15px;\n    margin-right: 15px;\n    margin-bottom: -5px;\n}\n.checkbox-setting-row {\n    display: flex;\n    align-items: center;\n    margin: 0 40px 0 15px;\n}\n\n.checkbox-label {\n    flex: auto;\n    min-width: 0;\n    width: 180px;\n    position: relative;\n    box-sizing: border-box;\n}\n\n.checkbox-icons {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    padding: 4px 15px 0 0;\n}\n\n.setting-icon {\n    cursor: pointer;\n}\n\n.settings {\n    overflow-y: auto;\n    max-height: 53vh;\n}\n\n.setting {\n    display: inline-block;\n    @media (max-width: 767px) {\n        width: 100%;\n    }\n    @media (min-width: 768px) {\n        width: 50%;\n    }\n}\n\n.setting-options {\n    padding: 12px 5px;\n    cursor: pointer;\n}\n\n.settings-container {\n    display: inline;\n    @media (max-width: 767px) {\n        width: 50vh;\n    }\n    @media (min-width: 768px) and ( max-width: 991px) {\n        width: 65vh;\n    }\n    @media (min-width: 992px) {\n        width: 75vh;\n    }\n}\n\n/*TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n.mat-select-value-text {\n    white-space: break-spaces !important;\n    overflow: visible !important;\n}\n\n.row-padding {\n    margin-top: 15px;\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n}\n\n.tooltip {\n    display: block;\n    position: relative;\n    top: 2em;\n    right: 100%;\n    width: 140px;\n    height: 96px;\n    /*margin-left: -76px;*/\n    color: #FFFFFF;\n    background: #000000;\n    line-height: 96px;\n    text-align: center;\n    border-radius: 8px;\n    box-shadow: 4px 3px 10px #800000;\n}\n.tooltip:after {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    margin-left: -8px;\n    width: 0;\n    height: 0;\n    border-bottom: 8px solid #000000;\n    border-right: 8px solid transparent;\n    border-left: 8px solid transparent;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
